import type { QuoteFormError } from 'state/addonForm/addonForm.selector';

import type { DynamicFormState } from '..';
import type { DynamicFormInfos } from './infos.model';
export function getFormInfos(state: DynamicFormState, tabId: string): DynamicFormInfos | undefined {
  return state.infos[tabId];
}

export function getFormQuoteId(state: DynamicFormState, tabId: string): string | undefined {
  const infos = getFormInfos(state, tabId);
  return infos ? infos.quoteId : undefined;
}
export function getTabIdsByQuoteId(state: DynamicFormState, quoteId: string): readonly string[] {
  const tabIds = [];

  for (const tabId in state.infos) {
    const info = state.infos[tabId];
    if (quoteId === info.quoteId) {
      tabIds.push(tabId);
    }
  }

  return tabIds;
}

const emptyValidationErrors: readonly [] = [];

export function getFormValidationErrors(state: DynamicFormState, tabId: string): readonly QuoteFormError[] {
  return getFormInfos(state, tabId)?.validationErrors ?? emptyValidationErrors;
}

export function getDynamicFormIsEnrichmentError(state: DynamicFormState, tabId: string): boolean {
  const infos = getFormInfos(state, tabId);
  return infos?.enrichmentError !== undefined;
}
